import {isNotNil} from 'ramda';

import type {EagGridState} from '../store/createEagGridStore';
import {selectOrderedVisibleColumns} from '../store/selectors/selectOrderedVisibleColumns';
import type {EagColumn} from '../types/EagColumn';

/** Resolve visibility and display order from current state, even for an already-open menu. */
export function getClipboardColumns(state: EagGridState, definitions: EagColumn[]): EagColumn[] {
  const byKey = new Map(definitions.map((column) => [column.key, column]));
  return selectOrderedVisibleColumns(state)
    .map((column) => byKey.get(column.key))
    .filter(isNotNil);
}
